import { useGetAllMetadataCurrency } from "../../api/currency";

export interface Root {
  id: number;
  symbol: string;
  type: string;
}

export const useAllMetadataCurrency = () => {
  const {
    data = {
      data: { data: [] },
    },
    isLoading,
  } = useGetAllMetadataCurrency();

  const metadataAllCurrency = data?.data?.data?.map((item: Root) => {
    return {
      value: item.id,
      label: item.symbol,
    };
  });

  return { metadataAllCurrency, dataAllCurrency: data?.data?.data, isLoading };
};
